// LIBRARIES
import styled from "styled-components";

// MISC
import { BOXSHADOW, COLORS, FONTS, WIDTH } from "constants/styleVariables";

export const NewcomeUsersContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 40px 0 0 0;
  @media (${WIDTH.mediumWidth}) {
    margin-left: 0px;
  }
`;

export const NewcomeUsersContainerTitle = styled.div`
  font-family: ${FONTS.montserrat};
  font-size: 20px;
  font-weight: bold;
`;

export const NewcomeUsersWrapper = styled.div`
  width: 100%;
  height: 340px;
  border-radius: 24px;
  background-color: #F5F5F5;
  padding: 10px 20px 20px 20px;
  margin-top: 20px;
  @media (${WIDTH.mediumWidth}) {
    width: 620px;
  }
  @media (${WIDTH.tabletWidth}) {
    width: 600px;
  }
`;

export const NewcomeUsersContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${COLORS.backgroundColor};
    border-radius: 10px;
    margin-block: 9px;
    margin-left: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(
      180deg,
      ${COLORS.rainbowIndigo} 0%,
      ${COLORS.rainbowIndigo} 100%
    );
    border-radius: 10px;
  }
`;
